import { useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

export default function useMarketProfile() {
  const [saving, setSaving] = useState(false);

  const saveProfile = useCallback(async (data) => {
    setSaving(true);
    try {
      const res = await axios.put(`${API}/market/profile/me/`, data);
      return res.data;
    } finally {
      setSaving(false);
    }
  }, []);

  return { saveProfile, saving };
}
